import '@ant-design/v5-patch-for-react-19';
import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { configureStore } from './app/redux/store/store';
import App from '@app/App';
import './styles/global.less';
import { Skeleton } from 'antd';
import logger from '@app/utils/logger';
import useLocalStorage from '@app/hooks/useLocalStorage';
// Initialize Application Insights
import '@app/utils/applicationInsights';
// Initialize Datadog RUM (dynamic import inside; skipped on localhost)
import '@app/utils/datadogRum';

export const store = configureStore();

const fetchColorData = async () => {
  try {
    const response = await fetch('/data/colors.json');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    logger.error('GenericMethods', 'fetchColorData', error);
    return null;
  }
};

const updateStyles = (colors: any) => {
  if (!colors) return;

  const updatedStyles = `
    :root {
      --color-primary: ${colors.primaryColor};
      --color-secondary: ${colors.secondaryColor};
      --color-tertiary: ${colors.tertiaryColor};
      --color-accent: ${colors.accentColor};
      --color-white: ${colors.whiteColor};
      --color-gray-light: ${colors.lightGrayColor};
      --color-gray-medium: ${colors.mediumGrayColor};
      --color-black: ${colors.blackColor};
    }
  `;

  const styleElement = document.createElement('style');
  styleElement.innerHTML = updatedStyles;
  document.head.appendChild(styleElement);
};
const versionKey = 'version';

const PreLoad = () => {
  const [authURL] = useState<string>(
    (window as any)._env_?.REACT_APP_URL_AUTH || process.env.REACT_APP_URL_AUTH
  );
  const [localVersion, setLocalVersion] = useLocalStorage(versionKey, []);

  const clearLocalStorage = () => {
    const version = (window as any)._env_?.REACT_APP_VERSION || process.env.REACT_APP_VERSION;
    if (localVersion != version) {
      localStorage.clear();
      setLocalVersion(version);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      const colors = await fetchColorData();
      updateStyles(colors);
      await clearLocalStorage();
    };
    initialize();
  }, []);

  if (authURL)
    return (
      <Provider store={store}>
        <App authUrl={authURL} />
      </Provider>
    );
  else return <Skeleton />;
};

// Use createRoot instead of ReactDOM.render
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container); // Create a root
  root.render(<PreLoad />); // Render the app
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
